import { Decimal, type DecimalString } from "@/lib/decimal";

const GRAMS_PER_UNIT: Record<string, string> = {
  g: "1",
  mg: "0.001",
  kg: "1000",
  ct: "0.2",
  oz: "28.349523125",
  ozt: "31.1034768",
  lb: "453.59237",
  dwt: "1.55517384",
};

/** Grams from a signed number and a unit field ("+00012.345", "g"); null for counts and unknown units. */
export function toGrams(sign: string, digits: string, unit: string): DecimalString | null {
  const factor = GRAMS_PER_UNIT[unit.trim().toLowerCase()];
  const value = Decimal.tryFrom(digits.replace(/\s+/g, ""));
  if (factor === undefined || value === null) return null;
  const grams = factor === "1" ? value : value.times(factor);
  return (sign === "-" && !grams.isZero() ? grams.negate() : grams).toString();
}
